<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：通知サブ画面
 *
 * 作成者：2021/12/1 ノア）黄
 * 最終修正者：2022/01/30 ノア）黄
 *
 -->
<template>
  <div class="tti-notifications" :class="{ ttiNotificationsOpen: isShow }">
    <el-tabs v-model="currentTab" :stretch="true" @tab-click="onTabClick">
      <!-- 通知 -->
      <el-tab-pane :name="tabType.notifications">
        <span slot="label">
          {{ $t('notifications.notifications') }}
          <el-badge v-if="unReadNotificationsNumber" :value="unReadNotificationsNumber" />
        </span>

        <div class="paneBody">
          <!-- ヘッダー -->
          <div class="contentHead">
            <el-select
              class="notifications-select"
              v-model="currentFilter"
              @change="onFilterCurrentData"
              v-tooltip="{
                content: `${$t('notifications.notificationsTypeTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <el-option v-for="item in getFilterList()" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <div class="keyWord">
              <el-input
                :placeholder="$t('notifications.keyword')"
                v-model.trim="currentKeyword"
                @input="onFilterCurrentData"
                v-tooltip="{
                  content: `${$t('notifications.keywordTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon class="input__icon" slot="suffix" icon-name="su_016"></tti-svg-icon>
              </el-input>
            </div>
            <el-checkbox
              v-model="isVehicleCooperationChecked"
              @change="onFilterCurrentData"
              v-tooltip="{
                content: `${$t('notifications.vehicleCooperationTip', [managementTarget])}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              {{ $t('notifications.vehicleCooperation', [managementTarget]) }}
            </el-checkbox>
          </div>
          <!-- 内容 -->
          <div class="contentBody">
            <div class="messageAreaTitle">
              <span>{{ $t('notifications.receivedNotifications') }}</span>
              <span
                @click="onReceivedBtnClick"
                v-tooltip="{
                  content: `${$t('notifications.notificationUnreadTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="su_000" class="unreadIcon"></tti-svg-icon>
              </span>
            </div>
            <div class="messageAreaContent messageContentHeight">
              <div v-for="(el, ind) in notificationsListForPage" :key="el.notificationId">
                <div class="messageBody" :class="{ beSelected: el.selected }">
                  <div class="messageTop" :class="{ unread: !el.isRead }" @click="selectMessage(ind)">
                    <div class="messageTitle">
                      {{
                        getDefinitionName(filterData[GeneralType.NOTIFICATIONS_TYPE], el.notificationType, {
                          code: 'code',
                          value: 'name'
                        })
                      }}
                    </div>
                    <div class="messageTime" v-if="!el.selected">
                      {{ el.sendTime }}{{ $t('notifications.timeInterval', [getCurrentTimeInterval(el.sendTime)]) }}
                    </div>
                  </div>
                  <div class="messageContent" v-if="el.selected">
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.managementObjectCode', [managementTarget]) }}</div>
                      <div class="contentArea">{{ el.managementTargetCode }}</div>
                    </div>
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.managementObjectName', [managementTarget]) }}</div>
                      <div class="contentArea">{{ el.managementTargetName }}</div>
                    </div>
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.dateTime') }}</div>
                      <div class="contentArea">
                        <div>{{ el.sendTime }}</div>
                        <div>{{ $t('notifications.timeInterval', [getCurrentTimeInterval(el.sendTime)]) }}</div>
                      </div>
                    </div>
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.managementPlaceCode') }}</div>
                      <div class="contentArea">{{ el.managementPlaceCode }}</div>
                    </div>
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.managementPlaceName') }}</div>
                      <div class="contentArea">{{ el.managementPlaceName }}</div>
                    </div>
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.arrivalStatus') }}</div>
                      <div class="contentArea">
                        {{
                          getDefinitionName(arrivalStatus, el.arrivalStatus, {
                            code: 'code',
                            value: 'name'
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- フッター -->
          <div class="contentFoot">
            <el-button
              class="tti-btn-default tti-btn-006"
              @click="onMessageSendClick"
              v-tooltip="{
                content: `${$t('notifications.sendMessageTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <tti-svg-icon icon-name="su_1033"></tti-svg-icon>
              {{ $t('buttons.sendMessage') }}
            </el-button>
            <el-button
              class="tti-btn-default tti-btn-002"
              @click="onCloseSideBarBtnClick"
              v-tooltip="{
                content: `${$t('notifications.closeTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <tti-svg-icon icon-name="su_005"></tti-svg-icon>
              {{ $t('buttons.close') }}
            </el-button>
          </div>
        </div>
      </el-tab-pane>
      <!-- メッセージ -->
      <el-tab-pane :name="tabType.message">
        <span slot="label">
          {{ $t('notifications.messageTitle') }}
          <el-badge v-if="unReadMessageNumber" :value="unReadMessageNumber" />
        </span>

        <div class="paneBody message">
          <!-- ヘッダー -->
          <div class="contentHead">
            <div class="keyWord">
              <el-input
                :placeholder="$t('notifications.keyword')"
                v-model.trim="currentKeyword"
                @input="onFilterCurrentData"
                v-tooltip="{
                  content: `${$t('notifications.keywordTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon class="input__icon" slot="suffix" icon-name="su_016"></tti-svg-icon>
              </el-input>
            </div>
          </div>
          <!-- 内容 -->
          <div class="contentBody">
            <div class="messageAreaTitle">
              <span>{{ $t('notifications.receivedMessage') }}</span>
              <span
                @click="onReceivedBtnClick"
                v-tooltip="{
                  content: `${$t('notifications.messageUnreadTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="su_000" class="unreadIcon"></tti-svg-icon>
              </span>
            </div>
            <div class="messageAreaContent messageContentHeight">
              <div v-for="(el, ind) in messageListForPage" :key="el.messageId">
                <div class="messageBody" :class="{ beSelected: el.selected }">
                  <div class="messageTop" :class="{ unread: !el.isRead }" @click="selectMessage(ind)">
                    <div class="messageTitle">{{ el.title }}</div>
                    <div class="messageTime" v-if="!el.selected">
                      {{ el.sendDate }}{{ $t('notifications.timeInterval', [getCurrentTimeInterval(el.sendDate)]) }}
                    </div>
                  </div>
                  <div class="messageContent" v-if="el.selected">
                    <div class="messageContentBody" v-if="el.context1">
                      <div class="contentTitle">{{ $t('notifications.context1') }}</div>
                      <div class="contentArea">{{ el.context1 }}</div>
                    </div>
                    <div class="messageContentBody" v-if="el.context2">
                      <div class="contentTitle">{{ $t('notifications.context2') }}</div>
                      <div class="contentArea">{{ el.context2 }}</div>
                    </div>
                    <div class="messageContentBody" v-if="el.context3">
                      <div class="contentTitle">{{ $t('notifications.context3') }}</div>
                      <div class="contentArea">{{ el.context3 }}</div>
                    </div>
                    <div class="messageContentBody" v-if="el.context4">
                      <div class="contentTitle">{{ $t('notifications.context4') }}</div>
                      <div class="contentArea">{{ el.context4 }}</div>
                    </div>
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.typeLabel') }}</div>
                      <div class="contentArea">
                        <span class="mr-10">{{
                          getDefinitionName(filterData[GeneralType.MESSAGE_SEND_TYPE], el.sendType, {
                            code: 'code',
                            value: 'name'
                          })
                        }}</span>
                      </div>
                    </div>
                    <div class="messageContentBody">
                      <div class="contentTitle">{{ $t('notifications.sendTime') }}</div>
                      <div class="contentArea">
                        <div>{{ el.sendDate }}</div>
                        <div>{{ $t('notifications.timeInterval', [getCurrentTimeInterval(el.sendDate)]) }}</div>
                      </div>
                    </div>
                    <div class="messageContentBody" v-if="userDbId === el.sendUserId">
                      <div class="width-table">
                        <el-table
                          header-row-class-name="tti-master-table-header"
                          border
                          :stripe="true"
                          :data="el.receiverUserInfoList"
                          @selection-change="handleSelectionChange($event, el)"
                          max-height="200"
                        >
                          <el-table-column fixed type="selection" width="35"> </el-table-column>
                          <el-table-column prop="userId" :label="$t('notifications.userCode')" width="120">
                          </el-table-column>
                          <el-table-column prop="userName" :label="$t('notifications.userName')" width="120">
                          </el-table-column>
                          <el-table-column prop="address" :label="$t('notifications.sendStatus')" show-overflow-tooltip>
                            <template slot-scope="scope">{{
                              getDefinitionName(messageSendStatus, scope.row.status, {
                                code: 'code',
                                value: 'name'
                              })
                            }}</template>
                          </el-table-column>
                        </el-table>
                        <div class="table-btn">
                          <el-button
                            class="tti-btn-default tti-btn-006"
                            @click="onReSendClick(el)"
                            v-tooltip="{
                              content: `${$t('notifications.selectedUserResendMessageTip')}`,
                              placement: 'bottom-start',
                              delay: { show: 1000, hide: 0 }
                            }"
                          >
                            <tti-svg-icon icon-name="su_1033"></tti-svg-icon>
                            {{ $t('notifications.reSend') }}
                          </el-button>
                          <el-button
                            class="tti-btn-default tti-btn-006"
                            @click="onReSendClick(el, true)"
                            v-tooltip="{
                              content: `${$t('notifications.allUserResendMessageTip')}`,
                              placement: 'bottom-start',
                              delay: { show: 1000, hide: 0 }
                            }"
                          >
                            <tti-svg-icon icon-name="su_1033"></tti-svg-icon>
                            {{ $t('notifications.allReSend') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- フッター -->
          <div class="contentFoot">
            <el-button
              class="tti-btn-default tti-btn-006"
              @click="onMessageSendClick"
              v-tooltip="{
                content: `${$t('notifications.sendMessageTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <tti-svg-icon icon-name="su_1033"></tti-svg-icon>
              {{ $t('buttons.sendMessage') }}
            </el-button>
            <el-button
              class="tti-btn-default tti-btn-002"
              @click="onCloseSideBarBtnClick"
              v-tooltip="{
                content: `${$t('notifications.closeTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <tti-svg-icon icon-name="su_005"></tti-svg-icon>
              {{ $t('buttons.close') }}
            </el-button>
          </div>
        </div>
      </el-tab-pane>
      <!-- アナウンス -->
      <el-tab-pane :name="tabType.announce">
        <span slot="label">
          {{ $t('notifications.announceTitle') }}
          <el-badge v-if="unReadAnnounceNumber" :value="unReadAnnounceNumber" />
        </span>

        <div class="paneBody">
          <!-- ヘッダー -->
          <div class="contentHead">
            <el-select
              class="notifications-select"
              v-model="currentFilter"
              @change="onFilterCurrentData"
              v-tooltip="{
                content: `${$t('notifications.notificationsTypeTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <el-option v-for="item in getFilterList()" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <div class="keyWord">
              <el-input
                :placeholder="$t('notifications.keyword')"
                v-model.trim="currentKeyword"
                @input="onFilterCurrentData"
                v-tooltip="{
                  content: `${$t('notifications.keywordTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon class="input__icon" slot="suffix" icon-name="su_016"></tti-svg-icon>
              </el-input>
            </div>
          </div>
          <!-- 内容 -->
          <div class="contentBody">
            <div class="messageAreaTitle">
              <span>{{ $t('notifications.receivedAnnounce') }}</span>
              <span
                @click="onReceivedBtnClick"
                v-tooltip="{
                  content: `${$t('notifications.announceUnreadTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              >
                <tti-svg-icon icon-name="su_000" class="unreadIcon"></tti-svg-icon>
              </span>
            </div>
            <div class="messageAreaContent messageContentHeight">
              <div v-for="(el, ind) in announceListForPage" :key="el.announceId">
                <div class="messageBody" :class="{ beSelected: el.selected }">
                  <div class="messageTop" :class="{ unread: !el.isRead }" @click="selectMessage(ind)">
                    <div class="messageTitle">
                      <span
                        class="noticeIcon"
                        :class="{
                          noticeIcon2: el.sendType === AnnounceType.COMPANY,
                          noticeIcon3: el.sendType === AnnounceType.BUSINESS_OFFICE
                        }"
                      ></span
                      >{{ el.title }}
                    </div>
                    <div class="messageTime" v-if="!el.selected">{{ el.sendTime }}</div>
                  </div>
                  <div class="messageContent" v-if="el.selected">
                    <div class="messageContentBody">{{ el.context }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- フッター -->
          <div class="contentFoot">
            <el-button
              class="tti-btn-default tti-btn-002"
              @click="onMessageSendClick"
              v-tooltip="{
                content: `${$t('notifications.sendNotificationsTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <tti-svg-icon icon-name="su_1033"></tti-svg-icon>
              {{ $t('buttons.sendNotifications') }}
            </el-button>
            <el-button
              class="tti-btn-default tti-btn-002"
              @click="onCloseSideBarBtnClick"
              v-tooltip="{
                content: `${$t('notifications.closeTip')}`,
                placement: 'bottom-start',
                delay: { show: 1000, hide: 0 }
              }"
            >
              <tti-svg-icon icon-name="su_005"></tti-svg-icon>
              {{ $t('buttons.close') }}
            </el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'

import { dialog } from '@/store/modules'
import {
  General,
  NotificationsParam,
  NotificationsListItem,
  AcceptUserInfo,
  AnnounceListItem,
  MessageListItem,
  MessageSend
} from '@/models'
import { NotificationsType, AnnounceType, MessageSendType } from '@/commons/constants'
import { common } from '@/store/modules'
import {
  getNotificationsList,
  updateNotificationsList,
  getAnnounceList,
  updateAnnounceList,
  getMessageList,
  updateMessageList,
  messageSend
} from '@/store/apis'
import { generalService, GeneralType } from '@/commons/services/generalService'
import HelperService from '@/service/helperService'
import { localService } from '@/commons/services/localService'
import { msgBoxService } from '@/commons/services/msgBoxService'
import { i18n } from '@/locales'
import { getTimeInterval } from '@/utils/dateUtils'
import { audioService } from '@/components/audio/audioService'

@Component({
  name: 'home-notifications'
})
export default class HOME_NOTIFICATIONS extends Vue {
  GeneralType = GeneralType

  AnnounceType = AnnounceType

  /**
   * ユーザID(DBキー)
   */
  userDbId = localService.userInfo?.id || ''

  /**
   * ログインユーザの営業所ID
   */
  userBusinessOfficeId = localService.userInfo?.businessOfficeId || ''

  /**
   * タブタイプ
   */
  tabType = {
    notifications: GeneralType.NOTIFICATIONS_TYPE,
    message: GeneralType.MESSAGE_SEND_TYPE,
    announce: GeneralType.ANNOUNCE_TYPE
  }

  /**
   * 選択しているタブ
   */
  currentTab = this.tabType.notifications

  /**
   * フィルターデータ
   */
  filterData: Record<string, General[]> = {
    [GeneralType.NOTIFICATIONS_TYPE]: [],
    [GeneralType.MESSAGE_SEND_TYPE]: [],
    [GeneralType.ANNOUNCE_TYPE]: []
  }

  /**
   * 選択しているフィルタ
   */
  currentFilter: string = NotificationsType.ALL

  /**
   * 入力しているキーワード
   */
  currentKeyword = ''

  /**
   * 管理対象連携チェックボックス
   */
  isVehicleCooperationChecked = false

  /**
   * 入出区分リスト
   */
  arrivalStatus: General[] = []

  /**
   * メッセージ種
   */
  messageTypeOptions: General[] = []

  /**
   * 送信状況
   */
  messageSendStatus: General[] = []

  /**
   * 通知一覧
   */
  notificationsList: NotificationsListItem[] = []

  /**
   * 通知一覧画面用
   */
  notificationsListForPage: NotificationsListItem[] = []

  /**
   * アナウンス一覧
   */
  announceList: AnnounceListItem[] = []

  /**
   * アナウンス一覧画面用
   */
  announceListForPage: AnnounceListItem[] = []

  /**
   * アナウンス一覧
   */
  messageList: MessageListItem[] = []

  /**
   * アナウンス一覧画面用
   */
  messageListForPage: MessageListItem[] = []

  getDefinitionName = HelperService.getDefinitionName

  /**
   * 管理対象
   */
  managementTarget = localService.userInfo?.managementTargetShowName || i18n.t('commons.managementTarget')

  unReadNotificationsNumberSelf = 0
  unReadMessageNumberSelf = 0
  unReadAnnounceNumberSelf = 0

  get unReadNotificationsNumber(): number {
    return this.unReadNotificationsNumberSelf
  }
  set unReadNotificationsNumber(value: number) {
    this.unReadNotificationsNumberSelf = value
    common.setUnreadTotalCounts([
      this.unReadNotificationsNumberSelf,
      this.unReadMessageNumberSelf,
      this.unReadAnnounceNumberSelf
    ])
  }

  get unReadMessageNumber(): number {
    return this.unReadMessageNumberSelf
  }
  set unReadMessageNumber(value: number) {
    this.unReadMessageNumberSelf = value
    common.setUnreadTotalCounts([
      this.unReadNotificationsNumberSelf,
      this.unReadMessageNumberSelf,
      this.unReadAnnounceNumberSelf
    ])
  }

  get unReadAnnounceNumber(): number {
    return this.unReadAnnounceNumberSelf
  }
  set unReadAnnounceNumber(value: number) {
    this.unReadAnnounceNumberSelf = value
    common.setUnreadTotalCounts([
      this.unReadNotificationsNumberSelf,
      this.unReadMessageNumberSelf,
      this.unReadAnnounceNumberSelf
    ])
  }

  /**
   * 通知サブ画面の表示フラグを取得
   *
   * @returns {boolean} 通知サブ画面の表示フラグ
   */
  get isShow(): boolean {
    return dialog.isNotificationsDialogShow
  }

  /**
   * 通知サブ画面の表示フラグを設定する
   *
   * @param {boolean} value 通知サブ画面の表示フラグ
   */
  set isShow(value: boolean) {
    dialog.setNotificationsDialogShow()
  }

  /**
   * 気に入り営業所
   *
   * @returns {string[]} 気に入り営業所
   */
  get watchedFavOfficeList(): string[] {
    return common.favOfficeList
  }

  /**
   * 気に入り営業所変更した時の処理
   *
   * @param {string[]} value  気に入り営業所
   * @returns {void}
   */
  @Watch('watchedFavOfficeList', { immediate: true, deep: true })
  onFavOfficeChange(value: string[]): void {
    if (!value || value.length === 0) {
      return
    }
    const notificationsParam = {
      businessOfficeList: value
    }

    this.fetchNotifications(notificationsParam)
    this.fetchAnnounce()
    this.fetchMessage()
  }

  /**
   * mqtt通知
   *
   * @returns {NotificationsListItem} mqtt通知
   */
  get watchedNotificationsMqttData(): NotificationsListItem | null {
    return common.notificationsMqttData ? common.notificationsMqttData : null
  }

  /**
   * mqtt通知変更した時の処理
   *
   * @param {NotificationsListItem} value  mqtt通知
   * @returns {void}
   */
  @Watch('watchedNotificationsMqttData', { immediate: true, deep: true })
  onNotificationsMqttDataChange(value: NotificationsListItem): void {
    if (!value) {
      return
    }

    if (common.favOfficeList.indexOf(value.businessOfficeId) === -1) {
      return
    }

    const resultValue = cloneDeep(value)
    this.notificationsList.unshift(resultValue)

    this.notificationsListForPage = this.filterListData(
      this.notificationsList,
      GeneralType.NOTIFICATIONS_TYPE
    ) as NotificationsListItem[]

    audioService.play()
  }

  /**
   * mqttメッセージ
   *
   * @returns {MessageListItem} mqttメッセージ
   */
  get watchedMessageMqttData(): MessageListItem | null {
    return common.messageMqttData ? common.messageMqttData : null
  }

  /**
   * mqttメッセージ変更した時の処理
   *
   * @param {MessageListItem} value  mqttメッセージ
   * @returns {void}
   */
  @Watch('watchedMessageMqttData', { immediate: true, deep: true })
  onMessageMqttDataChange(value: MessageListItem): void {
    if (!value) {
      return
    }

    let isReceiveUserId = false
    if (value.receiverUserInfoList) {
      isReceiveUserId = value.receiverUserInfoList.some(item => item.receiveUserId === this.userDbId)
    }

    if (value.sendUserId !== this.userDbId && !isReceiveUserId) {
      return
    }

    const resultValue = cloneDeep(value)
    this.messageList.unshift(resultValue)

    this.messageListForPage = this.filterListData(this.messageList, GeneralType.MESSAGE_SEND_TYPE) as MessageListItem[]

    audioService.play()
  }

  /**
   * mqttアナウンス
   *
   * @returns {AnnounceListItem} mqttアナウンス
   */
  get watchedAnnounceMqttData(): AnnounceListItem | null {
    return common.announceMqttData ? common.announceMqttData : null
  }

  /**
   * mqttアナウンス変更した時の処理
   *
   * @param {AnnounceListItem} value  mqttアナウンス
   * @returns {void}
   */
  @Watch('watchedAnnounceMqttData', { immediate: true, deep: true })
  onAnnounceMqttDataChange(value: AnnounceListItem): void {
    if (!value) {
      return
    }

    if (value.sendType !== AnnounceType.COMPANY && value.businessOfficeId !== this.userBusinessOfficeId) {
      return
    }

    const resultValue = cloneDeep(value)

    this.announceList.unshift(resultValue)

    this.announceListForPage = this.filterListData(this.announceList, GeneralType.ANNOUNCE_TYPE) as AnnounceListItem[]

    audioService.play()
  }

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  mounted(): void {
    this.$log.debug('HOME_NOTIFICATIONS > mounted')
    this.fetchMasterData()
  }

  /**
   * 通知取得する
   *
   * @param {NotificationsParam} notificationsParam 通知一覧取得のパラメータ
   * @returns {Promise<void>}
   */
  async fetchNotifications(notificationsParam: NotificationsParam): Promise<void> {
    try {
      const notificationsData = await getNotificationsList(notificationsParam)
      this.notificationsList = notificationsData ? (notificationsData.list as NotificationsListItem[]) : []

      this.notificationsListForPage = this.filterListData(
        this.notificationsList,
        GeneralType.NOTIFICATIONS_TYPE
      ) as NotificationsListItem[]
      this.$log.debug('HOME_NOTIFICATIONS > fetchNotifications: notificationsList=', this.notificationsList)
    } catch (e) {
      this.$log.debug('HOME_NOTIFICATIONS > fetchNotifications: e=', e)
      throw e
    }
  }

  /**
   * アナウンス取得する
   *
   * @returns {Promise<void>}
   */
  async fetchAnnounce(): Promise<void> {
    try {
      const announceData = await getAnnounceList()
      this.announceList = announceData ? (announceData.list as AnnounceListItem[]) : []

      this.announceListForPage = this.filterListData(this.announceList, GeneralType.ANNOUNCE_TYPE) as AnnounceListItem[]
      this.$log.debug('HOME_NOTIFICATIONS > fetchAnnounce: announceList=', this.announceList)
    } catch (e) {
      this.$log.debug('HOME_NOTIFICATIONS > fetchAnnounce: e=', e)
      throw e
    }
  }

  /**
   * メッセージ取得する
   *
   * @returns {Promise<void>}
   */
  async fetchMessage(): Promise<void> {
    try {
      const messageData = await getMessageList()
      this.messageList = messageData ? (messageData.list as MessageListItem[]) : []

      this.messageListForPage = this.filterListData(
        this.messageList,
        GeneralType.MESSAGE_SEND_TYPE
      ) as MessageListItem[]
      this.$log.debug('HOME_NOTIFICATIONS > fetchMessage: messageList=', this.messageList)
    } catch (e) {
      this.$log.debug('HOME_NOTIFICATIONS > fetchMessage: e=', e)
      throw e
    }
  }

  /**
   * フィルターデータ
   *
   * @param {NotificationsListItem[]} listData 一覧データ
   * @param {string} currentTab 選択しているタブ
   * @returns {NotificationsListItem[]} フィルターデータ
   */
  // eslint-disable-next-line
  filterListData(
    // eslint-disable-next-line
    listData: Array<any>,
    currentTab: string
  ): Array<NotificationsListItem | AnnounceListItem | MessageListItem> {
    // eslint-disable-next-line
    let data: any[] = []

    if (currentTab === GeneralType.NOTIFICATIONS_TYPE) {
      const tempListData = listData as NotificationsListItem[]
      if (this.currentFilter === NotificationsType.ALL) {
        data = tempListData
      } else {
        data = tempListData.filter(item => item.notificationType === this.currentFilter)
      }

      if (this.currentKeyword) {
        data = data.filter(item => {
          const notificationTypeName = this.getDefinitionName(
            this.filterData[GeneralType.NOTIFICATIONS_TYPE],
            item.notificationType,
            { code: 'code', value: 'name' }
          )
          if (notificationTypeName.indexOf(this.currentKeyword) > -1) {
            return true
          } else {
            return false
          }
        })
      }

      if (this.isVehicleCooperationChecked) {
        if (!common.selectedManagementObject) {
          data = []
        }
        if (common.selectedManagementObject) {
          data = data.filter(item => {
            if (item.managementTargetId === common.selectedManagementObject) {
              return true
            } else {
              return false
            }
          })
        }
      }

      data = this.sortArray(data, 'sendTime')
    }

    if (currentTab === GeneralType.ANNOUNCE_TYPE) {
      const tempListData = listData as AnnounceListItem[]
      if (this.currentFilter === AnnounceType.ALL) {
        data = tempListData
      } else if (this.currentFilter === AnnounceType.UNREAD) {
        data = tempListData.filter(item => !item.isRead)
      } else {
        data = tempListData.filter(item => item.sendType === this.currentFilter)
      }

      if (this.currentKeyword) {
        data = data.filter(item => item.title.indexOf(this.currentKeyword) > -1)
      }

      data = this.sortArray(data, 'sendTime')
    }

    if (currentTab === GeneralType.MESSAGE_SEND_TYPE) {
      const tempListData = listData as MessageListItem[]
      data = tempListData
      if (this.currentKeyword) {
        data = tempListData.filter(item => item.title.indexOf(this.currentKeyword) > -1)
      }

      data.forEach((item, index) => {
        if (!item.multipleSelection) {
          this.$set(data[index], 'multipleSelection', [])
        }
      })

      data = this.sortArray(data, 'sendDate')
    }

    data.forEach((item, index) => {
      if (!item.selected) {
        this.$set(data[index], 'selected', false)
      }

      if (!item.isRead) {
        let readFlag
        if (currentTab === GeneralType.MESSAGE_SEND_TYPE) {
          readFlag = this.getMessageIsRead(item)
        } else {
          readFlag = this.getIsRead(item.userInfoList)
        }
        this.$set(data[index], 'isRead', readFlag)
      }
    })

    if (currentTab === GeneralType.NOTIFICATIONS_TYPE) {
      this.unReadNotificationsNumber = this.getUnreadNumber(data)
    }
    if (currentTab === GeneralType.MESSAGE_SEND_TYPE) {
      this.unReadMessageNumber = this.getUnreadNumber(data)
    }
    if (currentTab === GeneralType.ANNOUNCE_TYPE) {
      this.unReadAnnounceNumber = this.getUnreadNumber(data)
    }

    return data
  }

  // eslint-disable-next-line
  getUnreadNumber(dataList: any[]): number {
    let unReadNumber = 0
    dataList.forEach(item => {
      if (!item.isRead) {
        unReadNumber++
      }
    })

    return unReadNumber
  }

  /**
   * フィルターデータ
   *
   * @returns {void}
   */
  onFilterCurrentData(): void {
    if (this.currentTab === GeneralType.NOTIFICATIONS_TYPE) {
      this.notificationsListForPage = this.filterListData(
        this.notificationsList,
        GeneralType.NOTIFICATIONS_TYPE
      ) as NotificationsListItem[]
    }

    if (this.currentTab === GeneralType.ANNOUNCE_TYPE) {
      this.announceListForPage = this.filterListData(this.announceList, GeneralType.ANNOUNCE_TYPE) as AnnounceListItem[]
    }

    if (this.currentTab === GeneralType.MESSAGE_SEND_TYPE) {
      this.messageListForPage = this.filterListData(
        this.messageList,
        GeneralType.MESSAGE_SEND_TYPE
      ) as MessageListItem[]
    }
  }

  /**
   * 既読と未読の判断
   *
   * @param {AcceptUserInfo[]} userInfoList 受信ユーザ情報リスト
   * @returns {boolean} 既読と未読
   */
  getIsRead(userInfoList: AcceptUserInfo[]): boolean {
    if (!userInfoList || userInfoList.length === 0) {
      return false
    }

    let readFlag = false
    userInfoList.forEach(item => {
      if (item.userId === this.userDbId) {
        if (item.readFlag === '0') {
          readFlag = false
        } else if (item.readFlag === '1') {
          readFlag = true
        }
      }
    })

    return readFlag
  }

  /**
   * メッセージ既読と未読の判断
   *
   * @param {MessageListItem} data メッセージ情報
   * @returns {boolean} 既読と未読
   */
  getMessageIsRead(data: MessageListItem): boolean {
    let readFlag = false

    if (this.userDbId === data.sendUserId) {
      if (data.senderReadFlag === '0') {
        readFlag = false
      } else if (data.senderReadFlag === '1') {
        readFlag = true
      }
    } else {
      data.receiverUserInfoList.forEach(item => {
        if (item.receiveUserId === this.userDbId) {
          if (item.readFlag === '0') {
            readFlag = false
          } else if (item.readFlag === '1') {
            readFlag = true
          }
        }
      })
    }

    return readFlag
  }

  /**
   * 通知情報を選択する
   *
   * @param {number} index 通知
   * @returns {void}
   */
  selectMessage(index: number): void {
    if (this.currentTab === GeneralType.NOTIFICATIONS_TYPE) {
      this.notificationsListForPage.forEach((item, idx) => {
        if (idx !== index) {
          item.selected = false
        }
      })
      this.notificationsListForPage[index].selected = !this.notificationsListForPage[index].selected

      if (!this.notificationsListForPage[index].isRead) {
        this.updateNotifications(this.notificationsListForPage[index])
      }
    }

    if (this.currentTab === GeneralType.ANNOUNCE_TYPE) {
      this.announceListForPage.forEach((item, idx) => {
        if (idx !== index) {
          item.selected = false
        }
      })
      this.announceListForPage[index].selected = !this.announceListForPage[index].selected

      if (!this.announceListForPage[index].isRead) {
        this.updateAnnounce(this.announceListForPage[index])
      }
    }

    if (this.currentTab === GeneralType.MESSAGE_SEND_TYPE) {
      this.messageListForPage.forEach((item, idx) => {
        if (idx !== index) {
          item.selected = false
        }
      })
      this.messageListForPage[index].selected = !this.messageListForPage[index].selected

      if (!this.messageListForPage[index].isRead) {
        this.updateMessage(this.messageListForPage[index])
      }
    }
  }

  /**
   * 通知更新
   *
   * @param {NotificationsListItem} data 通知情報
   * @returns {Promise<void>}
   */
  async updateNotifications(data: NotificationsListItem): Promise<void> {
    const params = {
      notificationId: data.notificationId, // 通知ID
      readFlag: data.isRead ? '0' : '1' // 既読フラグ "0"：未読、"1"：既読
    }

    try {
      await updateNotificationsList(params)
      if (data.isRead) {
        data.isRead = false
        data.selected = false
      } else {
        data.isRead = true
      }

      this.unReadNotificationsNumber = this.getUnreadNumber(this.notificationsListForPage)
    } catch (e) {
      return
    }
  }

  /**
   * アナウンス更新
   *
   * @param {AnnounceListItem} data アナウンス情報
   * @returns {Promise<void>}
   */
  async updateAnnounce(data: AnnounceListItem): Promise<void> {
    const params = {
      announceId: data.announceId, // アナウンスID
      readFlag: data.isRead ? '0' : '1' // 既読フラグ "0"：未読、"1"：既読
    }

    try {
      await updateAnnounceList(params)
      if (data.isRead) {
        data.isRead = false
        data.selected = false
      } else {
        data.isRead = true
      }

      this.unReadAnnounceNumber = this.getUnreadNumber(this.announceListForPage)
    } catch (e) {
      return
    }
  }

  /**
   * メッセージ更新
   *
   * @param {MessageListItem} data メッセージ情報
   * @returns {Promise<void>}
   */
  async updateMessage(data: MessageListItem): Promise<void> {
    let params
    if (this.userDbId === data.sendUserId) {
      params = {
        messageId: data.messageId,
        sendUserId: this.userDbId,
        senderReadFlag: data.isRead ? '0' : '1'
      }
    } else {
      params = {
        messageId: data.messageId,
        receiveUserId: this.userDbId,
        receiverReadFlag: data.isRead ? '0' : '1'
      }
    }

    try {
      await updateMessageList(params)
      if (data.isRead) {
        data.isRead = false
        data.selected = false
      } else {
        data.isRead = true
      }

      this.unReadMessageNumber = this.getUnreadNumber(this.messageListForPage)
    } catch (e) {
      return
    }
  }

  /**
   * 汎用定義通知タイプを取得する
   *
   * @returns {void}
   */
  async fetchMasterData(): Promise<void> {
    try {
      // 通知
      const notifications = await generalService[GeneralType.NOTIFICATIONS_TYPE]
      this.filterData[GeneralType.NOTIFICATIONS_TYPE] = notifications
      // メッセージ
      const message = await generalService[GeneralType.MESSAGE_SEND_TYPE]
      this.filterData[GeneralType.MESSAGE_SEND_TYPE] = message
      // アナウンス
      const announce = await generalService[GeneralType.ANNOUNCE_TYPE]
      this.filterData[GeneralType.ANNOUNCE_TYPE] = announce
      // 入出区分
      this.arrivalStatus = await generalService[GeneralType.ARRIVAL_STATUS]
      // 送信状況
      this.messageSendStatus = await generalService[GeneralType.SEND_STATUS]
    } catch (e) {
      this.$log.debug('HOME_NOTIFICATIONS > fetchMasterData: e=', e)
      throw e
    }
  }

  /**
   * テーブルのチェックしたデータを変更する
   *
   * @param {Array<any>} val チェックされたデータリスト
   * @param {MessageListItem} data メッセージ
   * @returns {void}
   */
  // eslint-disable-next-line
  handleSelectionChange(val: Array<any>, data: MessageListItem): void {
    data.multipleSelection = val
  }

  /**
   * 再送信
   *
   * @param {MessageListItem} data 受信ユーザ
   * @param {boolean} isAll 全部再送信OR再送信
   */
  onReSendClick(data: MessageListItem, isAll = false): void {
    if (!isAll && (!data.multipleSelection || data.multipleSelection.length === 0)) {
      msgBoxService.info(i18n.t('vaildate.common.selectRequired', [i18n.t('notifications.reSendRow')]).toString())
      return
    }

    this.reSendMessage(data, isAll)
  }

  /**
   * 再送信
   *
   * @param {MessageListItem} row 受信ユーザ
   * @param {boolean} isAll 全部再送信OR再送信
   * @returns {void}
   */
  async reSendMessage(row: MessageListItem, isAll: boolean): Promise<void> {
    let receiveUserList: string[] = []
    if (isAll) {
      receiveUserList = row.receiverUserInfoList.map(item => item.receiveUserId)
    } else {
      receiveUserList = row.multipleSelection ? row.multipleSelection.map(item => item.receiveUserId) : []
    }

    const params = {
      sendType: MessageSendType.IMMEDIATE, // 即時送信
      title: row.title,
      context1: row.context1,
      context2: row.context2,
      context3: row.context3,
      context4: row.context4,
      receiveUserList: receiveUserList
    } as MessageSend

    try {
      await messageSend(params)
      msgBoxService.info(i18n.t('notifications.I00060').toString())
    } catch (e) {
      return
    }
  }

  /**
   * 画面のフィルターを取得する
   *
   * @returns {General} フィルターリスト
   */
  getFilterList(): General[] {
    if (!this.filterData) {
      return []
    }

    return this.filterData[this.currentTab]
  }

  /**
   * タブを変更した時の処理
   *
   * @returns {void}
   */
  onTabClick(): void {
    this.$log.debug('HOME_NOTIFICATIONS > onTabClick')
    this.initFilter()
  }

  /**
   * 未読ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onReceivedBtnClick(): void {
    if (this.currentTab === GeneralType.NOTIFICATIONS_TYPE) {
      let allNoSelected = true
      this.notificationsListForPage.forEach(item => {
        if (item.selected) {
          this.updateNotifications(item)

          allNoSelected = false
        }
      })

      if (allNoSelected) {
        msgBoxService.info(i18n.t('vaildate.common.selectRequired', [i18n.t('notifications.notifications')]).toString())
      }
    }

    if (this.currentTab === GeneralType.ANNOUNCE_TYPE) {
      let allNoSelected = true
      this.announceListForPage.forEach(item => {
        if (item.selected) {
          this.updateAnnounce(item)

          allNoSelected = false
        }
      })

      if (allNoSelected) {
        msgBoxService.info(i18n.t('vaildate.common.selectRequired', [i18n.t('notifications.announceTitle')]).toString())
      }
    }

    if (this.currentTab === GeneralType.MESSAGE_SEND_TYPE) {
      let allNoSelected = true
      this.messageListForPage.forEach(item => {
        if (item.selected) {
          this.updateMessage(item)

          allNoSelected = false
        }
      })

      if (allNoSelected) {
        msgBoxService.info(i18n.t('vaildate.common.selectRequired', [i18n.t('notifications.messageTitle')]).toString())
      }
    }
  }

  /**
   * 通知送信ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onMessageSendClick(): void {
    this.$log.debug('HOME_NOTIFICATIONS > onMessageSendClick')
    if (this.currentTab === this.tabType.announce) {
      dialog.setNotificationsSendDialogShow(true)
    } else {
      dialog.setMessageSendDialogShow(true)
    }
  }

  /**
   * 通知ダイアログの閉じるボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onCloseSideBarBtnClick(): void {
    this.initFilter()
    dialog.setNotificationsDialogShow()
  }

  /**
   * フィルターを初期化する
   *
   * @returns {void}
   */
  initFilter(): void {
    this.currentFilter = NotificationsType.ALL
    this.currentKeyword = ''
    this.isVehicleCooperationChecked = false

    this.onFilterCurrentData()
  }

  /**
   * 時間間隔を取得する
   *
   * @param {string} sendTime 日時
   * @returns {number} 時間間隔
   */
  getCurrentTimeInterval(sendTime: string): number {
    return getTimeInterval(sendTime)
  }

  /**
   * 配列の並べ替え
   *
   * @param {any[]} arr 配列
   * @param {string} key key
   * @returns {any[]} 配列
   */
  // eslint-disable-next-line
  sortArray(arr: any[], key: string): any[] {
    if (!arr) return []

    // eslint-disable-next-line
    arr.sort((a: any, b: any) => {
      if (a[key] < b[key]) return 1
      if (a[key] > b[key]) return -1
      return 0
    })

    return arr
  }
}
</script>

<style scoped lang="scss">
::v-deep .cell {
  text-overflow: unset;
}

.tti-notifications {
  display: none;
  position: absolute;
  top: 48px;
  right: -332px;
  z-index: 100;
  width: 332px;
  height: calc(100vh - 48px);
  min-height: 671px;
  text-align: left;
  background: $C02;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}

.ttiNotificationsOpen {
  display: block;
  right: 0;
  box-shadow: 0 8px 32px 1px rgb(0, 0, 0, 90%);
}

.notifications-select {
  width: 100%;
}

.keyWord {
  margin: 8px 0;
}

.tti-keyword-search {
  cursor: pointer;
  color: black;
}

.contentHead {
  height: 120px;
  padding: 0 10px;
  margin-bottom: 10px;
}

.contentBody {
  height: calc(100% - 190px);
  background-color: white;
  color: #333;
}

.messageContentHeight {
  height: calc(100% - 54px);
  overflow-y: auto;
}

.message {
  .contentHead {
    height: 60px;
  }

  .contentBody {
    height: calc(100% - 140px);
  }

  .messageContentHeight {
    height: calc(100% - 54px);
    overflow-y: auto;
  }
}

.el-tabs.el-tabs--top,
.el-tab-pane,
.paneBody {
  height: 100%;
}

::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}

.messageAreaTitle {
  padding: 20px 12px 0 12px;
  margin-bottom: 8px;
  color: #777;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.messageAreaContent {
  .beSelected {
    border-right: 3px solid $C45;
  }

  .unread {
    font-weight: bold;
  }

  .messageTop {
    margin-bottom: 12px;
    margin-left: 22px;
    cursor: pointer;

    .messageTitle {
      display: inline-block;
      width: 270px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .noticeIcon {
      display: inline-block;
      width: 24px;
      height: 16px;
    }

    .noticeIcon2 {
      background: url(/public/images/bellIcon.png) -48px -72px no-repeat;
    }

    .noticeIcon3 {
      background: url(/public/images/bellIcon.png) -24px 0 no-repeat;
    }
  }

  .messageContent {
    margin-bottom: 12px;
    margin-left: 22px;
    font-size: 14px;

    .messageContentBody {
      display: flex;

      .contentTitle {
        width: 120px;
        margin-right: 20px;
      }

      .contentArea {
        width: 160px;
        word-break: break-word;
      }
    }
  }
}

.contentFoot {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.mr-10 {
  margin-right: 10px;
}

.width-table {
  width: 290px;
}

.table-btn {
  display: flex;
  margin-top: 5px;
  margin-bottom: 10px;
}

.el-badge {
  position: absolute !important;
}

::v-deep .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px !important;
}

.unreadIcon {
  width: 16px !important;
  height: 16px !important;
  cursor: pointer;
}
</style>
